import React, { useState, useEffect } from "react";

import { LockOutlined, UserOutlined, SyncOutlined } from "@ant-design/icons";
import {
  Button, Form, Input, notification,
} from "antd";

import { signIn } from "../../api/login";

import "./Login.css";

export default function Login(routeProps) {
  const { history } = routeProps;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  /**
   * Check if the login route contains "type=unauthorized". If it does, show
   * a notification and clean the URL.
   */
    function checkLoginParam() {
      if (window.location.search.includes("unauthorized")) {
        notification.error({
          message: "Login Failed",
          description: "Authentication failed.",
        });
        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, "", cleanUrl);
      }
    }
    checkLoginParam();
  }, []);

  /**
   * onFinish is the callback for when the form is submitted.
   * It trims the email ID and password, and then calls signIn with them.
   * If the signIn call is successful, it redirects to the /user-configuration route.
   * If the signIn call fails, it shows an error notification.
   * The notification is also shown if there is an error making the signIn call.
   * The loading state is set to true while the signIn call is being made, and
   * set back to false when the call is finished (regardless of success or failure).
   */
  const onFinish = async ({ email, password }) => {
    setLoading(true);
    try {
      const response = await signIn(email.trim(), password.trim());

      if (response?.success) {
        history.push("/user-configuration");
      } else {
        notification.error({
          message: "Login Failed",
          description: response?.message || "Please check your inputs",
        });
      }
    } catch (error) {
      notification.error({
        message: "Login Failed",
        description: error?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-from-container">
        <div className="login-header-container">
          <h1 className="login-header">Log in</h1>
          <span className="login-header-text">Please enter your details below to sign in.</span>
        </div>
        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Please input your Email ID!" },
              { type: "email", message: "Please enter a valid email address!" },
            ]}
          >
            <Input prefix={<UserOutlined />} placeholder="Email ID" type="email" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password prefix={<LockOutlined />} type="password" placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button block type="primary" htmlType="submit" loading={loading && { icon: <SyncOutlined spin /> }}>
              Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
